<template>
    <form-row title="Property Address">
        <div class="flex-1 -mt-2">
            <div>
                <input-text
                    name="address"
                    :value="property.address"
                    label="Address"
                    placeholder="Address"
                    :read_only="read_only"
                />
            </div>

            <div class="mt-3">
                <input-text
                    name="address_2"
                    :value="property.address_2"
                    label="Address 2"
                    placeholder="Address 2"
                    :read_only="read_only"
                />
            </div>

            <div class="flex flex-col sm:flex-row mt-3">
                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-text
                        name="city"
                        :value="property.city"
                        label="City"
                        placeholder="City"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-select-states
                        label="State"
                        name="state"
                        no_selection="Select State"
                        :value="property.state"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-text
                        name="zip"
                        :value="property.zip"
                        label="Zip"
                        placeholder="Zip"
                        :read_only="read_only"
                    />
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        property: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
